// Tiny DOM helper — keeps the UI code declarative without a framework.

type Props = Record<string, any>;
type Child = Node | string | null | undefined | false;

export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  props: Props = {},
  children: Child[] = [],
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  for (const [k, v] of Object.entries(props)) {
    if (v == null || v === false) continue;
    if (k === 'class') node.className = v;
    else if (k === 'style' && typeof v === 'object') Object.assign(node.style, v);
    else if (k === 'dataset') Object.assign(node.dataset, v);
    else if (k.startsWith('on') && typeof v === 'function') {
      node.addEventListener(k.slice(2).toLowerCase(), v);
    } else if (k in node) (node as any)[k] = v;
    else node.setAttribute(k, String(v));
  }
  for (const c of children) {
    if (c == null || c === false) continue;
    node.append(typeof c === 'string' ? document.createTextNode(c) : c);
  }
  return node;
}

// The layout's modal host (ui/layout.ts). Dialogs mount here so they are laid out below the
// critical band (HUD + alarm) and dimmed by the one shared scrim. Falls back to <body> before the
// layout exists (e.g. the auth gate).
let modalHostEl: HTMLElement | null = null;
export function setModalHost(host: HTMLElement): void {
  modalHostEl = host;
}
export function modalHost(): HTMLElement {
  return modalHostEl ?? document.body;
}
